import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';

// Apply persisted theme before first paint to avoid flash.
const stored = localStorage.getItem('vaultex-theme');
const mode = stored ? (JSON.parse(stored).state?.mode ?? 'dark') : 'dark';
document.documentElement.classList.toggle('dark', mode === 'dark');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
